import { Injectable } from '@angular/core';
import * as CryptoJS from 'crypto-ts';

@Injectable({
  providedIn: 'root'
})
export class CryptoService {

  constructor() { }

  private secretKey = 'aflkdj;fioperwquiofdjkapoer'

  public encodeObject(object: any): string {
    return CryptoJS.AES.encrypt(JSON.stringify(object), this.secretKey).toString();
  }

  public decodeObject(str: string): any {
    const decryptedBytes = CryptoJS.AES.decrypt(str, this.secretKey);
    return JSON.parse(decryptedBytes.toString(CryptoJS.enc.Utf8));
  }
}
